import type { EventRead } from '@models/api';

/**
 * The going-set count to display for an event: `going_count` (WANT_TO_JOIN /
 * CONFIRMED) with `participant_count` as the fallback for payloads that
 * predate it (the field is optional until the backend serves it on every
 * event path — see the EventRead docstring). One definition so surfaces
 * can't drift on the fallback rule.
 */
export function getEventGoingCount(
  event: Pick<EventRead, 'going_count' | 'participant_count'>,
): number {
  return event.going_count ?? event.participant_count;
}
